import React from 'react';
import { withPrefix, Link } from 'gatsby';
import ReactMarkdown from 'react-markdown';
import Icon from '@mdi/react';
import { mdiDownload  } from '@mdi/js';


const styles = {
    inactive: {
        borderColor: '#b4cbce',
        color: '#a3babd',
        backgroundColor: '#fff'
    },
};
  
export default class AgbSwitcher extends React.Component {
    
    constructor(props) {
      super(props);
      this.state = {
        currentAGB: "B2B",
      };
    }
    
    

    render() {
        
        const agbs = this.props.agbs;

        return (
            <div className="blogpage">
                <div className="blog-content">
                    <div className="container">

                        <div className="switch" >
                            { agbs.map(({ node: agb }) => (
                                <span key={agb.frontmatter.agb}
                                    className="button is-rounded customers-button switcher-button"
                                    style={ agb.frontmatter.agb !== this.state.currentAGB ? styles.inactive : {}}
                                    onClick={() => {
                                        this.setState({
                                            currentAGB: agb.frontmatter.agb,
                                        })
                                    }} > { agb.frontmatter.buttonText }
                                </span>
                            ))}
                        </div>


                        { agbs.map(({ node: agb }) => (

                            

                            <div key={agb.frontmatter.agb}
                                style={{
                                    display: agb.frontmatter.agb === this.state.currentAGB ? "block" : "none"
                                }}> 
                                
                                <ReactMarkdown source={agb.html} escapeHtml={false}/>
                                <a className="button is-rounded features-button" target="_blank" href={agb.frontmatter.download}>
                                    <span className="icon">
                                    <Icon path={mdiDownload}
                                        size={"20px"}
                                        color="#fff"
                                        />
                                    </span>
                                    <span>Download AGBs als .PDF</span>
                                </a>
                            </div>
                        ))}

                        
                    </div>
                </div>
            </div>
        );
    }
  }
  